import React, { Component } from 'react'
import Invoice from '../../../components/invoice/invoice'

export default class CreateInvoice extends Component{
    render(){
        return <Invoice />
    }
}